/* ── Pro Import — Site Data ─────────────────────────────────────────────── */
window.PI = {};

PI.BRANDS = [
  {
    id: 'bajaj', name: 'Bajaj', type: 'bike', tagline: 'Sport & commuter bikes',
    models: [
      { id: 'pulsar-125',    name: 'Pulsar 125',    years: '2019—2024' },
      { id: 'pulsar-150',    name: 'Pulsar 150',    years: '2015—2024' },
      { id: 'pulsar-160f',   name: 'Pulsar 160F',   years: '2016—2024' },
      { id: 'pulsar-180',    name: 'Pulsar 180',    years: '2012—2024' },
      { id: 'pulsar-ns160',  name: 'Pulsar NS160',  years: '2021—2024' },
      { id: 'pulsar-ns200',  name: 'Pulsar NS200',  years: '2013—2024' },
      { id: 'pulsar-n150',   name: 'Pulsar N150',   years: '2022—2024' },
      { id: 'pulsar-n160',   name: 'Pulsar N160',   years: '2022—2024' },
      { id: 'pulsar-n250',   name: 'Pulsar N250',   years: '2022—2024' },
      { id: 'pulsar-rs200',  name: 'Pulsar RS200',  years: '2015—2024' },
      { id: 'dominar-250',   name: 'Dominar 250',   years: '2019—2024' },
      { id: 'dominar-400',   name: 'Dominar 400',   years: '2017—2024' },
      { id: 'avenger-160',   name: 'Avenger 160',   years: '2016—2024' },
      { id: 'avenger-220',   name: 'Avenger 220',   years: '2014—2024' },
      { id: 'ct100',         name: 'CT100',         years: '2010—2024' },
      { id: 'ct125x',        name: 'CT125X',        years: '2021—2024' },
      { id: 'platina-100',   name: 'Platina 100',   years: '2014—2024' },
      { id: 'platina-110',   name: 'Platina 110',   years: '2016—2024' },
      { id: 'discover-125',  name: 'Discover 125',  years: '2017—2024' },
      { id: 'discover-150',  name: 'Discover 150',  years: '2015—2023' },
    ],
  },
  {
    id: 'benelli', name: 'Benelli', type: 'bike', tagline: 'Italian motorcycles',
    models: [
      { id: 'tnt-135',       name: 'TNT 135',       years: '2018—2024' },
      { id: 'tnt-249s',      name: 'TNT 249S',      years: '2019—2024' },
      { id: 'tnt-300',       name: 'TNT 300',       years: '2015—2024' },
      { id: 'tnt-600i',      name: 'TNT 600i',      years: '2013—2022' },
      { id: '302r',          name: '302R',          years: '2016—2024' },
      { id: 'bn-302r',       name: 'BN 302R',       years: '2015—2024' },
      { id: 'trk-502',       name: 'TRK 502',       years: '2017—2024' },
      { id: 'trk-502x',      name: 'TRK 502X',      years: '2019—2024' },
      { id: 'trk-702',       name: 'TRK 702',       years: '2022—2024' },
      { id: '752s',          name: '752S',          years: '2019—2024' },
      { id: 'bn-502c',       name: 'BN 502C',       years: '2020—2024' },
      { id: 'leoncino-250',  name: 'Leoncino 250',  years: '2019—2024' },
      { id: 'leoncino-500',  name: 'Leoncino 500',  years: '2017—2024' },
      { id: 'imperiale-400', name: 'Imperiale 400', years: '2019—2024' },
      { id: 'panarea-125',   name: 'Panarea 125',   years: '2021—2024' },
      { id: 'rfs-150i',      name: 'RFS 150i',      years: '2019—2023' },
      { id: 'vz25',          name: 'VZ25',          years: '2017—2024' },
      { id: 'tornado-t135',  name: 'Tornado T135',  years: '2021—2024' },
      { id: 'zafferano-250', name: 'Zafferano 250', years: '2022—2024' },
      { id: 'cafe-nero-150', name: 'Caffè Nero 150',years: '2020—2024' },
    ],
  },
  {
    id: 'bmw', name: 'BMW', type: 'bike', tagline: 'Premium motorcycles',
    models: [
      { id: 's1000rr',       name: 'S1000RR',             years: '2009—2024' },
      { id: 's1000r',        name: 'S1000R',              years: '2014—2024' },
      { id: 's1000xr',       name: 'S1000XR',             years: '2015—2024' },
      { id: 'm1000rr',       name: 'M1000RR',             years: '2021—2024' },
      { id: 'm1000r',        name: 'M1000R',              years: '2023—2024' },
      { id: 'm1000xr',       name: 'M1000XR',             years: '2024—2024' },
      { id: 'r1250gs',       name: 'R1250GS',             years: '2018—2024' },
      { id: 'r1250gs-adv',   name: 'R1250GS Adventure',   years: '2019—2024' },
      { id: 'r1250r',        name: 'R1250R',              years: '2019—2024' },
      { id: 'r1250rs',       name: 'R1250RS',             years: '2019—2024' },
      { id: 'r1250rt',       name: 'R1250RT',             years: '2019—2024' },
      { id: 'f900r',         name: 'F900R',               years: '2020—2024' },
      { id: 'f900xr',        name: 'F900XR',              years: '2020—2024' },
      { id: 'f800gs',        name: 'F800GS',              years: '2013—2024' },
      { id: 'f750gs',        name: 'F750GS',              years: '2018—2024' },
      { id: 'g310r',         name: 'G310R',               years: '2017—2024' },
      { id: 'g310gs',        name: 'G310GS',              years: '2017—2024' },
      { id: 'g310rr',        name: 'G310RR',              years: '2022—2024' },
      { id: 'c400x',         name: 'C400X',               years: '2018—2024' },
      { id: 'c400gt',        name: 'C400GT',              years: '2019—2024' },
    ],
  },
  {
    id: 'ducati', name: 'Ducati', type: 'bike', tagline: 'Italian superbikes',
    models: [
      { id: 'panigale-v4',     name: 'Panigale V4',       years: '2018—2024' },
      { id: 'panigale-v4s',    name: 'Panigale V4S',      years: '2018—2024' },
      { id: 'panigale-v4r',    name: 'Panigale V4R',      years: '2019—2024' },
      { id: 'panigale-v2',     name: 'Panigale V2',       years: '2020—2024' },
      { id: 'monster-950',     name: 'Monster 950',       years: '2021—2024' },
      { id: 'monster-937',     name: 'Monster 937+',      years: '2022—2024' },
      { id: 'multistrada-v4',  name: 'Multistrada V4',    years: '2021—2024' },
      { id: 'multistrada-v4s', name: 'Multistrada V4S',   years: '2021—2024' },
      { id: 'multistrada-rally',name:'Multistrada V4 Rally',years:'2022—2024'},
      { id: 'scrambler-800',   name: 'Scrambler 800',     years: '2015—2024' },
      { id: 'scrambler-1100',  name: 'Scrambler 1100',    years: '2018—2024' },
      { id: 'scrambler-icon',  name: 'Scrambler Icon',    years: '2019—2024' },
      { id: 'desert-sled',     name: 'Desert Sled',       years: '2017—2024' },
      { id: 'streetfighter-v4',name: 'Streetfighter V4',  years: '2020—2024' },
      { id: 'streetfighter-v2',name: 'Streetfighter V2',  years: '2022—2024' },
      { id: 'diavel-v4',       name: 'Diavel V4',         years: '2023—2024' },
      { id: 'xdiavel',         name: 'XDiavel',           years: '2016—2024' },
      { id: 'hypermotard-950', name: 'Hypermotard 950',   years: '2019—2024' },
      { id: 'desertx',         name: 'DesertX',           years: '2022—2024' },
      { id: 'supersport-950',  name: 'SuperSport 950',    years: '2021—2024' },
    ],
  },
  {
    id: 'honda', name: 'Honda', type: 'bike', tagline: 'Scooters & motorcycles',
    models: [
      { id: 'vision-110',    name: 'Vision 110',          years: '2012—2024' },
      { id: 'pcx-125',       name: 'PCX 125',             years: '2010—2024' },
      { id: 'pcx-160',       name: 'PCX 160',             years: '2021—2024' },
      { id: 'sh-125',        name: 'SH 125',              years: '2012—2024' },
      { id: 'sh-150',        name: 'SH 150',              years: '2012—2024' },
      { id: 'adv-150',       name: 'ADV 150',             years: '2019—2024' },
      { id: 'adv-350',       name: 'ADV 350',             years: '2022—2024' },
      { id: 'lead-125',      name: 'Lead 125',            years: '2008—2024' },
      { id: 'forza-125',     name: 'Forza 125',           years: '2015—2024' },
      { id: 'forza-350',     name: 'Forza 350',           years: '2021—2024' },
      { id: 'forza-750',     name: 'Forza 750',           years: '2021—2024' },
      { id: 'cb125r',        name: 'CB125R',              years: '2018—2024' },
      { id: 'cb300r',        name: 'CB300R',              years: '2018—2024' },
      { id: 'cb500f',        name: 'CB500F',              years: '2013—2024' },
      { id: 'cb500x',        name: 'CB500X',              years: '2013—2024' },
      { id: 'cb650r',        name: 'CB650R',              years: '2019—2024' },
      { id: 'cb750-hornet',  name: 'CB750 Hornet',        years: '2023—2024' },
      { id: 'cb1000r',       name: 'CB1000R',             years: '2018—2024' },
      { id: 'cbr500r',       name: 'CBR500R',             years: '2013—2024' },
      { id: 'cbr1000rr-r',   name: 'CBR1000RR-R Fireblade',years:'2020—2024'},
    ],
  },
  {
    id: 'triumph', name: 'Triumph', type: 'bike', tagline: 'British motorcycles',
    models: [
      { id: 'street-triple-s',   name: 'Street Triple S',       years: '2017—2024' },
      { id: 'street-triple-r',   name: 'Street Triple R',       years: '2017—2024' },
      { id: 'street-triple-rs',  name: 'Street Triple RS',      years: '2017—2024' },
      { id: 'street-triple-m2',  name: 'Street Triple Moto2',   years: '2020—2024' },
      { id: 'tiger-900',         name: 'Tiger 900',             years: '2020—2024' },
      { id: 'tiger-900-gt',      name: 'Tiger 900 GT',          years: '2020—2024' },
      { id: 'tiger-900-gt-pro',  name: 'Tiger 900 GT Pro',      years: '2020—2024' },
      { id: 'tiger-900-rally',   name: 'Tiger 900 Rally',       years: '2020—2024' },
      { id: 'tiger-900-rally-pro',name:'Tiger 900 Rally Pro',   years: '2020—2024' },
      { id: 'tiger-1200-gt',     name: 'Tiger 1200 GT',         years: '2022—2024' },
      { id: 'tiger-1200-rally',  name: 'Tiger 1200 Rally',      years: '2022—2024' },
      { id: 'bonneville-t100',   name: 'Bonneville T100',       years: '2016—2024' },
      { id: 'bonneville-t120',   name: 'Bonneville T120',       years: '2016—2024' },
      { id: 'bonneville-bobber', name: 'Bonneville Bobber',     years: '2017—2024' },
      { id: 'thruxton-rs',       name: 'Thruxton RS',           years: '2020—2024' },
      { id: 'trident-660',       name: 'Trident 660',           years: '2021—2024' },
      { id: 'speed-triple-rs',   name: 'Speed Triple 1200RS',   years: '2021—2024' },
      { id: 'speed-triple-rr',   name: 'Speed Triple 1200RR',   years: '2022—2024' },
      { id: 'rocket-3-r',        name: 'Rocket 3 R',            years: '2020—2024' },
      { id: 'daytona-660',       name: 'Daytona 660',           years: '2024—2024' },
    ],
  },
  {
    id: 'ktm', name: 'KTM', type: 'bike', tagline: 'Ready to race',
    models: [
      { id: 'duke-125',       name: 'Duke 125',        years: '2011—2024' },
      { id: 'duke-200',       name: 'Duke 200',        years: '2012—2024' },
      { id: 'duke-250',       name: 'Duke 250',        years: '2017—2024' },
      { id: 'duke-390',       name: 'Duke 390',        years: '2013—2024' },
      { id: 'duke-790',       name: 'Duke 790',        years: '2018—2023' },
      { id: 'duke-890',       name: 'Duke 890',        years: '2021—2024' },
      { id: 'duke-990',       name: 'Duke 990',        years: '2024—2024' },
      { id: 'duke-890-r',     name: '890 Duke R',      years: '2020—2024' },
      { id: 'rc-125',         name: 'RC 125',          years: '2014—2024' },
      { id: 'rc-200',         name: 'RC 200',          years: '2014—2024' },
      { id: 'rc-390',         name: 'RC 390',          years: '2014—2024' },
      { id: 'rc-8c',          name: 'RC 8C',           years: '2023—2024' },
      { id: 'adventure-250',  name: 'Adventure 250',   years: '2019—2024' },
      { id: 'adventure-390',  name: 'Adventure 390',   years: '2020—2024' },
      { id: 'adventure-790',  name: 'Adventure 790',   years: '2019—2022' },
      { id: 'adventure-890',  name: 'Adventure 890',   years: '2021—2024' },
      { id: 'super-duke-r',   name: '1290 Super Duke R', years: '2020—2024' },
      { id: 'super-duke-gt',  name: '1290 Super Duke GT',years: '2020—2024' },
      { id: 'smt-890',        name: '890 SMT',         years: '2023—2024' },
      { id: 'sx-e5',          name: 'SX-E5',           years: '2019—2024' },
    ],
  },
  {
    id: 'kawasaki', name: 'Kawasaki', type: 'bike', tagline: 'Let the good times roll',
    models: [
      { id: 'ninja-125',      name: 'Ninja 125',     years: '2019—2024' },
      { id: 'ninja-300',      name: 'Ninja 300',     years: '2012—2024' },
      { id: 'ninja-400',      name: 'Ninja 400',     years: '2018—2024' },
      { id: 'ninja-650',      name: 'Ninja 650',     years: '2017—2024' },
      { id: 'ninja-zx4r',     name: 'Ninja ZX-4R',  years: '2023—2024' },
      { id: 'ninja-zx4rr',    name: 'Ninja ZX-4RR', years: '2023—2024' },
      { id: 'ninja-zx6r',     name: 'Ninja ZX-6R',  years: '2007—2024' },
      { id: 'ninja-zx10r',    name: 'Ninja ZX-10R', years: '2011—2024' },
      { id: 'ninja-zx10rr',   name: 'Ninja ZX-10RR',years: '2017—2024' },
      { id: 'ninja-h2',       name: 'Ninja H2',     years: '2015—2024' },
      { id: 'ninja-h2r',      name: 'Ninja H2R',    years: '2015—2024' },
      { id: 'z125-pro',       name: 'Z125 Pro',     years: '2016—2024' },
      { id: 'z400',           name: 'Z400',         years: '2019—2024' },
      { id: 'z650',           name: 'Z650',         years: '2017—2024' },
      { id: 'z650rs',         name: 'Z650RS',       years: '2022—2024' },
      { id: 'z900',           name: 'Z900',         years: '2017—2024' },
      { id: 'z900rs',         name: 'Z900RS',       years: '2018—2024' },
      { id: 'z1000',          name: 'Z1000',        years: '2014—2024' },
      { id: 'versys-650',     name: 'Versys 650',   years: '2015—2024' },
      { id: 'eliminator-500', name: 'Eliminator 500',years:'2023—2024' },
    ],
  },
  {
    id: 'cfmoto', name: 'CF Moto', type: 'bike', tagline: 'Performance at value',
    models: [
      { id: '150nk',          name: '150NK',          years: '2018—2024' },
      { id: '250nk',          name: '250NK',          years: '2019—2024' },
      { id: '300nk',          name: '300NK',          years: '2018—2024' },
      { id: '300sr',          name: '300SR',          years: '2020—2024' },
      { id: '400gt',          name: '400GT',          years: '2020—2024' },
      { id: '400nk',          name: '400NK',          years: '2019—2024' },
      { id: '450ss',          name: '450SS',          years: '2021—2024' },
      { id: '650gt',          name: '650GT',          years: '2019—2024' },
      { id: '650mt',          name: '650MT',          years: '2019—2024' },
      { id: '650nk',          name: '650NK',          years: '2015—2024' },
      { id: '700clx-heritage',name: '700CL-X Heritage',years:'2021—2024'},
      { id: '700clx-sport',   name: '700CL-X Sport',  years: '2021—2024' },
      { id: '700clx-adv',     name: '700CL-X Adventure',years:'2022—2024'},
      { id: '800mt-sport',    name: '800MT Sport',    years: '2022—2024' },
      { id: '800mt-explorer', name: '800MT Explorer', years: '2022—2024' },
      { id: '800mt-trail',    name: '800MT Trail',    years: '2023—2024' },
      { id: '1000mt',         name: '1000MT',         years: '2023—2024' },
      { id: '250sr',          name: '250SR',          years: '2020—2024' },
      { id: 'sr-s450',        name: 'SR-S 450',       years: '2023—2024' },
      { id: 'clx-700',        name: 'CLX 700',        years: '2021—2024' },
    ],
  },
  {
    id: 'suzuki', name: 'Suzuki', type: 'bike', tagline: 'Scooters & sport bikes',
    models: [
      { id: 'address-110',   name: 'Address 110',   years: '2014—2024' },
      { id: 'address-v125',  name: 'Address V125',  years: '2015—2024' },
      { id: 'burgman-125',   name: 'Burgman 125',   years: '2014—2024' },
      { id: 'burgman-200',   name: 'Burgman 200',   years: '2014—2024' },
      { id: 'burgman-400',   name: 'Burgman 400',   years: '2017—2024' },
      { id: 'vstrom-250',    name: 'V-Strom 250',   years: '2017—2024' },
      { id: 'vstrom-650',    name: 'V-Strom 650',   years: '2012—2024' },
      { id: 'vstrom-1000',   name: 'V-Strom 1000',  years: '2014—2024' },
      { id: 'gsxr-600',      name: 'GSX-R600',      years: '2006—2024' },
      { id: 'gsxr-750',      name: 'GSX-R750',      years: '2006—2024' },
      { id: 'gsxr-1000',     name: 'GSX-R1000',     years: '2001—2024' },
      { id: 'gsxr-1000r',    name: 'GSX-R1000R',    years: '2017—2024' },
      { id: 'gsxs-750',      name: 'GSX-S750',      years: '2015—2024' },
      { id: 'gsxs-1000',     name: 'GSX-S1000',     years: '2015—2024' },
      { id: 'gsxs-125',      name: 'GSX-S125',      years: '2017—2024' },
      { id: 'hayabusa',      name: 'Hayabusa',       years: '1999—2024' },
      { id: 'sv650',         name: 'SV650',         years: '1999—2024' },
      { id: 'sv650x',        name: 'SV650X',        years: '2018—2024' },
      { id: 'gixxer-250',    name: 'Gixxer 250',    years: '2019—2024' },
      { id: 'gsx-8s',        name: 'GSX-8S',        years: '2023—2024' },
    ],
  },
  {
    id: 'sym', name: 'SYM', type: 'bike', tagline: 'Taiwanese scooters',
    models: [
      { id: 'jet-14-125',    name: 'Jet 14 125',    years: '2014—2024' },
      { id: 'jet-14-150',    name: 'Jet 14 150',    years: '2014—2024' },
      { id: 'jet-x-125',     name: 'Jet X 125',     years: '2020—2024' },
      { id: 'jet-x-300',     name: 'Jet X 300',     years: '2022—2024' },
      { id: 'wolf-125',      name: 'Wolf Classic 125',years:'2010—2024'},
      { id: 'wolf-150',      name: 'Wolf Classic 150',years:'2010—2024'},
      { id: 'symphony-125',  name: 'Symphony 125',  years: '2012—2024' },
      { id: 'symphony-150',  name: 'Symphony 150',  years: '2012—2024' },
      { id: 'symphony-st',   name: 'Symphony ST 125',years:'2015—2024'},
      { id: 'maxsym-400',    name: 'Maxsym 400',    years: '2015—2024' },
      { id: 'maxsym-600',    name: 'Maxsym 600',    years: '2012—2024' },
      { id: 'maxsym-tl508',  name: 'Maxsym TL508',  years: '2020—2024' },
      { id: 'cruisym-125',   name: 'Cruisym 125',   years: '2016—2024' },
      { id: 'cruisym-300',   name: 'Cruisym 300',   years: '2016—2024' },
      { id: 'joymax-z-125',  name: 'Joymax Z 125',  years: '2020—2024' },
      { id: 'joymax-z-300',  name: 'Joymax Z 300',  years: '2020—2024' },
      { id: 'nhx-110',       name: 'NHX 110',       years: '2015—2024' },
      { id: 'fiddle-125',    name: 'Fiddle 125',    years: '2014—2024' },
      { id: 'galaxy-sr-150', name: 'Galaxy SR 150',  years: '2021—2024' },
      { id: 'citycom-s-300', name: 'Citycom S 300',  years: '2019—2024' },
    ],
  },
  {
    id: 'yamaha', name: 'Yamaha', type: 'bike', tagline: 'Scooters & motorcycles',
    models: [
      { id: 'nmax-125',      name: 'NMAX 125',      years: '2015—2024' },
      { id: 'nmax-155',      name: 'NMAX 155',      years: '2020—2024' },
      { id: 'xmax-125',      name: 'XMAX 125',      years: '2018—2024' },
      { id: 'xmax-300',      name: 'XMAX 300',      years: '2017—2024' },
      { id: 'xmax-400',      name: 'XMAX 400',      years: '2022—2024' },
      { id: 'delight-125',   name: 'Delight 125',   years: '2014—2024' },
      { id: 'aerox-155',     name: 'Aerox 155',     years: '2021—2024' },
      { id: 'fascino-125',   name: 'Fascino 125',   years: '2016—2024' },
      { id: 'yzf-r15',       name: 'YZF-R15',       years: '2017—2024' },
      { id: 'yzf-r3',        name: 'YZF-R3',        years: '2015—2024' },
      { id: 'yzf-r7',        name: 'YZF-R7',        years: '2021—2024' },
      { id: 'yzf-r25',       name: 'YZF-R25',       years: '2014—2024' },
      { id: 'mt-03',         name: 'MT-03',         years: '2015—2024' },
      { id: 'mt-07',         name: 'MT-07',         years: '2014—2024' },
      { id: 'mt-09',         name: 'MT-09',         years: '2014—2024' },
      { id: 'mt-10',         name: 'MT-10',         years: '2016—2024' },
      { id: 'tracer-9',      name: 'Tracer 9',      years: '2021—2024' },
      { id: 'tenere-700',    name: 'Ténéré 700',    years: '2019—2024' },
      { id: 'xsr700',        name: 'XSR700',        years: '2016—2024' },
      { id: 'fz-s-v3',       name: 'FZ-S V3',       years: '2019—2024' },
    ],
  },
  {
    id: 'van', name: 'Van', type: 'van', tagline: 'Commercial vans',
    models: [
      { id: 'maxus-deliver3',  name: 'Maxus Deliver 3',   years: '2019—2024' },
      { id: 'maxus-deliver9',  name: 'Maxus Deliver 9',   years: '2020—2024' },
      { id: 'maxus-edeliver3', name: 'Maxus eDeliver 3',  years: '2021—2024' },
      { id: 'maxus-edeliver9', name: 'Maxus eDeliver 9',  years: '2022—2024' },
      { id: 'merc-sprinter',   name: 'Mercedes Sprinter', years: '2006—2024' },
      { id: 'merc-vito',       name: 'Mercedes Vito',     years: '2003—2024' },
      { id: 'merc-metris',     name: 'Mercedes Metris',   years: '2016—2024' },
      { id: 'ford-transit',    name: 'Ford Transit',      years: '2000—2024' },
      { id: 'ford-t-connect',  name: 'Ford Transit Connect', years: '2013—2024' },
      { id: 'ford-t-custom',   name: 'Ford Transit Custom',  years: '2012—2024' },
    ],
  },
];

PI.GEAR_CATEGORIES = [
  {
    id: 'helmets', name: 'Helmets',
    items: ['Full Face Helmets', 'Open Face Helmets', 'Modular / Flip-up', 'Off-Road & Motocross', 'Half Shell', 'Adventure Dual-Sport'],
  },
  {
    id: 'gloves', name: 'Gloves',
    items: ['Racing Gloves', 'Touring Gloves', 'Off-Road Gloves', 'Summer Mesh Gloves', 'Winter & Heated', 'Short Cuff Urban'],
  },
  {
    id: 'jackets', name: 'Jackets',
    items: ['Leather Racing Jackets', 'Leather Touring Jackets', 'Textile Sport', 'Textile Adventure', 'Waterproof All-Season', 'High-Vis Jackets'],
  },
  {
    id: 'trousers', name: 'Trousers',
    items: ['Leather Trousers', 'Textile Trousers', 'Waterproof Overpants', 'Armoured Jeans', 'Adventure Pants', 'Thermal Lined'],
  },
  {
    id: 'boots', name: 'Boots',
    items: ['Racing Boots', 'Touring Boots', 'Adventure & Enduro', 'Urban Riding Boots', 'Waterproof Boots', 'Motocross Boots'],
  },
  {
    id: 'protective', name: 'Protection',
    items: ['Back Protectors', 'Chest Protectors', 'Knee & Shin Guards', 'Hip Protectors', 'Elbow Guards', 'Full Body Armour'],
  },
  {
    id: 'luggage', name: 'Luggage',
    items: ['Tank Bags', 'Throw-over Panniers', 'Hard Panniers', 'Top Cases', 'Tail Bags', 'Dry & Waterproof Bags'],
  },
  {
    id: 'accessories', name: 'Accessories',
    items: ['Bluetooth Intercoms', 'Action Cameras', 'Motorcycle Covers', 'Security Chains', 'GPS & Navigation', 'Grips & Risers'],
  },
];

PI.FEATURED_PARTS = [
  { name: 'Full Mud Guard Set',    compat: 'Honda PCX 125 / 160',     sku: 'HON-PCX-MG-001', tag: 'BEST SELLER', category: 'Body Parts'   },
  { name: 'Disc Brake Pad Set',    compat: 'KTM Duke 390',            sku: 'KTM-DK3-BP-002', tag: 'TOP SELLER',  category: 'Engine Parts' },
  { name: 'Front Fairing Panel',   compat: 'Yamaha YZF-R15 V3',      sku: 'YAM-R15-FP-003', tag: 'OEM',         category: 'Body Parts'   },
  { name: 'Cylinder Head Assembly',compat: 'Kawasaki Z900',           sku: 'KAW-Z90-CH-004', tag: 'OEM',         category: 'Engine Parts' },
  { name: 'Side Panel Cover',      compat: 'Bajaj Pulsar NS200',      sku: 'BAJ-NS2-SP-005', tag: '',            category: 'Body Parts'   },
  { name: 'CVT Drive Belt',        compat: 'Yamaha NMAX 125 / 155',   sku: 'YAM-NMX-CB-006', tag: 'OEM',         category: 'Engine Parts' },
  { name: 'Front Cowl Assembly',   compat: 'Honda SH 125 / 150',      sku: 'HON-SH1-FC-007', tag: 'NEW',         category: 'Body Parts'   },
  { name: 'Air Filter Kit',        compat: 'Kawasaki Ninja 400',      sku: 'KAW-N40-AF-008', tag: 'BEST SELLER', category: 'Engine Parts' },
];

PI.PART_CATEGORIES = [
  { id: 'body',   name: 'Body Parts',         count: 124, blurb: 'Panels, mudguards, cowls, mirrors, bumpers and exterior fittings for all major brands.' },
  { id: 'engine', name: 'Engine & Mechanical', count: 168, blurb: 'Engine internals, brakes, wheels, filters, electrical components and drivetrain parts.' },
];

PI.BIKE_BODY = [
  { name: 'Full Mud Guard Set',  tag: 'BEST SELLER', price: 28,  category: 'body' },
  { name: 'Front Mudguard',      tag: '',            price: 16,  category: 'body' },
  { name: 'Rear Mudguard',       tag: '',            price: 14,  category: 'body' },
  { name: 'Side Panel Cover',    tag: '',            price: 22,  category: 'body' },
  { name: 'Front Cowl Assembly', tag: 'NEW',         price: 35,  category: 'body' },
  { name: 'Floor Board',         tag: '',            price: 24,  category: 'body' },
  { name: 'Leg Shield',          tag: '',            price: 28,  category: 'body' },
  { name: 'Rear Luggage Rack',   tag: '',            price: 42,  category: 'body' },
];

PI.BIKE_ENGINE = [
  { name: 'Disc Brake Pad Set',   tag: 'BEST SELLER', price: 18,  category: 'engine' },
  { name: 'Front Brake Disc',     tag: '',            price: 48,  category: 'engine' },
  { name: 'Tubeless Tyre',        tag: '',            price: 62,  category: 'engine' },
  { name: 'Cast Alloy Wheel',     tag: 'NEW',         price: 120, category: 'engine' },
  { name: 'Forged Piston Kit',    tag: 'OEM',         price: 85,  category: 'engine' },
  { name: 'Crankshaft Assembly',  tag: '',            price: 165, category: 'engine' },
  { name: 'Cylinder Head',        tag: 'OEM',         price: 135, category: 'engine' },
  { name: 'Iridium Spark Plug',   tag: '',            price: 8,   category: 'engine' },
  { name: 'Carburetor Assembly',  tag: '',            price: 58,  category: 'engine' },
  { name: 'Fuel Injector',        tag: '',            price: 75,  category: 'engine' },
  { name: 'High-Flow Air Filter', tag: 'BEST SELLER', price: 12,  category: 'engine' },
  { name: 'CVT Drive Belt',       tag: 'OEM',         price: 28,  category: 'engine' },
  { name: 'Variator Assembly',    tag: '',            price: 95,  category: 'engine' },
];

PI.VAN_BODY = [
  { name: 'Front Bumper',        tag: 'BEST SELLER', price: 185, category: 'body' },
  { name: 'Rear Bumper',         tag: '',            price: 145, category: 'body' },
  { name: 'Front Grille',        tag: 'NEW',         price: 95,  category: 'body' },
  { name: 'Headlight Assembly',  tag: '',            price: 125, category: 'body' },
  { name: 'Tail Light Assembly', tag: '',            price: 82,  category: 'body' },
  { name: 'Front Fender',        tag: '',            price: 110, category: 'body' },
  { name: 'Side Door',           tag: '',            price: 295, category: 'body' },
  { name: 'Side Panel',          tag: '',            price: 128, category: 'body' },
  { name: 'Wing Mirror',         tag: '',            price: 55,  category: 'body' },
];

/* ── Generate full product catalogue ──────────────────────────────────────── */
(function () {
  PI.PRODUCTS = [];
  var _id  = 1000;
  var RATINGS  = [4.3, 4.4, 4.5, 4.6, 4.7, 4.8, 4.9, 5.0];
  var REVIEWS  = [12, 24, 38, 55, 67, 89, 102, 145, 178, 212];
  var ri = 0;

  PI.BRANDS.forEach(function (brand) {
    var parts = brand.type === 'van'
      ? PI.VAN_BODY
      : PI.BIKE_BODY.concat(PI.BIKE_ENGINE);

    brand.models.forEach(function (model) {
      parts.forEach(function (p) {
        var bCode = brand.name.replace(/\s+/g, '').substring(0, 3).toUpperCase();
        var mCode = model.name.replace(/[^a-zA-Z0-9]/g, '').substring(0, 3).toUpperCase();
        var pCode = p.name.split(' ').map(function (w) { return w[0]; }).join('').substring(0, 2).toUpperCase();
        var sku   = bCode + '-' + mCode + '-' + pCode + '-' + (++_id);
        var priceAdj = 0.88 + ((_id % 6) * 0.04);
        PI.PRODUCTS.push({
          sku:      sku,
          name:     p.name,
          brand:    brand.name,
          brandId:  brand.id,
          model:    model.name,
          modelId:  model.id,
          type:     brand.type,
          category: p.category,
          stock:    (_id % 8 === 0) ? 'low' : 'in',
          tag:      p.tag,
          price:    Math.round(p.price * priceAdj),
          rating:   RATINGS[ri % RATINGS.length],
          reviews:  REVIEWS[ri % REVIEWS.length],
        });
        ri++;
      });
    });
  });

  /* back-fill model.parts counts */
  PI.BRANDS.forEach(function (brand) {
    brand.models.forEach(function (model) {
      model.parts = PI.PRODUCTS.filter(function (p) {
        return p.brandId === brand.id && p.modelId === model.id;
      }).length;
    });
  });
}());
